import React, { useEffect, useRef, useState } from 'react'
import { AutoComplete, Button, DatePicker, Flex, Form, Input, Modal, notification, Radio, RadioChangeEvent, Select } from 'antd'
import '../AddRelative.scss'
import * as  selectOptionsApi from '../../../../api/selectOptions/selectOptionsApi'
import { fommatSelectOption, handleDateChangeDayJs } from '../../../../until'
import dayjs, { Dayjs } from "dayjs";
import { getListProfession } from '../../../../api/profession/professionApi'
import useToast from '../../../../hook/useToast'
import { useForm } from 'antd/es/form/Form'
import { set, values } from 'lodash'
import useThrottle from '../../../../hook/useThrottle'
import { ICustomerDetail_V2, ICustomerDetail_V4 } from '../../../../api/customer/customerApi'
import * as businessApi from '../../../../api/business/businessApi'
import useDebounce from '../../../../hook/useDebounce'

interface Props {
  show: boolean
  infoBusinessCustomer?: businessApi.IBusinessCustomers
  infoCustomer?: ICustomerDetail_V4;
  modalClose?: () => void
  onSuccess?: () => void
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void
}

const genders = [
  { value: 0, label: 'Nam', icon: <svg width="1.143em" height="1.143em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.4643 1H9.96429C9.90536 1 9.85714 1.04821 9.85714 1.10714V2.10714C9.85714 2.16607 9.90536 2.21429 9.96429 2.21429H12.8286L9.26964 5.77321C8.37679 5.08571 7.2875 4.71429 6.14286 4.71429C4.76964 4.71429 3.47679 5.25 2.50714 6.22143C1.5375 7.19286 1 8.48393 1 9.85714C1 11.2304 1.53571 12.5232 2.50714 13.4929C3.47679 14.4643 4.76964 15 6.14286 15C7.51607 15 8.80893 14.4643 9.77857 13.4929C10.75 12.5232 11.2857 11.2304 11.2857 9.85714C11.2857 8.7125 10.9143 7.62679 10.2286 6.73393L13.7857 3.17679V6.03572C13.7857 6.09464 13.8339 6.14286 13.8929 6.14286H14.8929C14.9518 6.14286 15 6.09464 15 6.03572V1.53571C15 1.24107 14.7589 1 14.4643 1ZM6.14286 13.6429C4.05536 13.6429 2.35714 11.9446 2.35714 9.85714C2.35714 7.76964 4.05536 6.07143 6.14286 6.07143C8.23036 6.07143 9.92857 7.76964 9.92857 9.85714C9.92857 11.9446 8.23036 13.6429 6.14286 13.6429Z" fill="#1890FF" /> </svg> },
  { value: 1, label: 'Nữ', icon: <svg width="1.143em" height="1.143em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clipPath="url(#clip0_15451_51524)"> <path d="M11.5859 8.65714C12.543 7.7 13.0716 6.425 13.0716 5.07143C13.0716 3.71607 12.5448 2.44286 11.5859 1.48571C10.6287 0.528571 9.35371 0 8.00014 0C6.64657 0 5.37157 0.526786 4.41443 1.48571C3.45728 2.44464 2.92871 3.71607 2.92871 5.07143C2.92871 6.21071 3.30193 7.29286 3.98943 8.17679C4.11978 8.34464 4.26085 8.50357 4.41264 8.65714C4.56443 8.80893 4.72514 8.95 4.89121 9.08036C5.59835 9.63036 6.43228 9.98036 7.32157 10.0982V12H5.28585C5.20728 12 5.143 12.0643 5.143 12.1429V13.2143C5.143 13.2929 5.20728 13.3571 5.28585 13.3571H7.32157V15.8571C7.32157 15.9357 7.38585 16 7.46443 16H8.53585C8.61443 16 8.67871 15.9357 8.67871 15.8571V13.3571H10.7144C10.793 13.3571 10.8573 13.2929 10.8573 13.2143V12.1429C10.8573 12.0643 10.793 12 10.7144 12H8.67871V10.0982C9.77693 9.95179 10.7894 9.45357 11.5859 8.65714ZM8.00014 8.78572C7.00728 8.78572 6.07693 8.4 5.37335 7.69821C4.67157 6.99643 4.28585 6.06429 4.28585 5.07143C4.28585 4.07857 4.67157 3.14821 5.37335 2.44464C6.07514 1.74107 7.00728 1.35714 8.00014 1.35714C8.993 1.35714 9.92335 1.74286 10.6269 2.44464C11.3287 3.14643 11.7144 4.07857 11.7144 5.07143C11.7144 6.06429 11.3287 6.99464 10.6269 7.69821C9.92335 8.4 8.993 8.78572 8.00014 8.78572Z" fill="#8C62FF" /> </g> <defs> <clipPath id="clip0_15451_51524"> <rect width="16" height="16" fill="white" /> </clipPath> </defs> </svg> },
]

const ModalUpdateContactCustomer: React.FC<Props> = (props) => {
  const {
    show, infoBusinessCustomer, infoCustomer,
    modalClose, onSuccess, onSubmitFormModal
  } = props
  const formRef: any = useRef(null)
  const [form] = useForm()
  const pushToast = useToast();

  const [loading, setLoading] = useState(false)

  const [sLCCCD, setSLCCCD] = useState<{ value: string }[]>([])
  const [sLProfession, setSLProfession] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProvice, setSLProvice] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLDistrict, setSLDistrict] = useState<selectOptionsApi.ISelectOption[]>([])

  const [isSelectedCCCD, setIsSelectedCCCD] = useState(false)

  const [birthday, setBirthday] = useState<string>()
  const [provice, setProvice] = useState<number>()


  const gSLCCCD = useDebounce(async (search?: string) => {
    const result = await selectOptionsApi.getCLSeachCCCDCustomer(search);
    if (result?.status) {
      const filteredOptions = result.data.map(item => ({ value: item?.CCCD }));
      setSLCCCD(filteredOptions)
    } else {
      pushToast(result?.message, "error")
    }
  }, 1000)


  const gSLProfession = async () => {
    const result = await getListProfession();
    if (result?.status) {
      setSLProfession(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
  }

  const gSLProvice = async () => {
    const result = await selectOptionsApi.getListProvince();
    if (result?.status) {
      setSLProvice(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
  }

  const gSLDistrict = useThrottle(async (idChange?: number, id?: number) => {
    const result = await selectOptionsApi.getListDistrict(Number(idChange));
    if (result?.status) {
      setSLDistrict(fommatSelectOption(result.data))
      if (id) {
        form.setFieldValue("quan", id)
      }
      else {
        form.setFieldValue("quan", undefined)
      }
    } else {
      pushToast(result?.message, "error")
    }
  }, 500)

  const gInfoBusinessr = async (CCCD: string) => {
    const result = await businessApi.getInfoCustomer(undefined, CCCD)
    if (result?.status) {
      fomatDataForm(true, result.data)
    } else {
      pushToast(result?.message, "error")
    }
  }

  const fomatDataForm = (isSearch: boolean, infoBusiness: businessApi.IBusinessCustomers) => {
    const {
      address, CCCD, birthday, district, email, gender, id, phoneBusiness, profession, province, username
    } = infoBusiness
    if (isSearch) {
      form.setFieldsValue({
        "CCCD": CCCD,
        "ho-ten": username,
        "gioi-tinh": gender,
        "email": email,
        "so-dien-thoai": phoneBusiness,
        "sinh-nhat": dayjs(birthday ?? null),
        "nghe-nghiep": profession?.id,
        "thanh-pho": province?.id,
        "quan": district?.id,
        "dia-chi": address,
      });

      gSLDistrict(province?.id, district?.id)

    } else {

    }
  }

  const handleSearchCCCD = (value: string) => {
    gSLCCCD(value)
  };

  const handleSelectCCCD = (value: string) => {
    gInfoBusinessr(value)
    setIsSelectedCCCD(true)
  };

  const onChaneProvice = (value: number) => {
    setSLDistrict([])
    gSLDistrict(value)
  }


  const onFormFinish = (values: any) => {
    const { 'ho-ten': hoTen,
      CCCD,
      'gioi-tinh': gioiTinh,
      'moi-quan-he': moiQuanHe,
      'email': email,
      'so-dien-thoai': soDienThoai,
      'sinh-nhat': sinhNhat,
      'nghe-nghiep': ngheNghiep,
      'thanh-pho': thanhPho,
      'quan': quan,
      'dia-chi': diaChi
    } = values;

    confimSubmit(hoTen, CCCD, gioiTinh, soDienThoai, handleDateChangeDayJs(sinhNhat), ngheNghiep, thanhPho, quan, diaChi, email);
  }

  const confimSubmit = async (
    hoTen: string, CCCD: string, gioiTinh: number, soDienThoai: string, birthday: string, ngheNghiep: number,
    thanhPho: number, quan: number, diaChi: string,
    email: string
  ) => {

    const result = await businessApi.editCustomer(
      Number(infoBusinessCustomer?.id), hoTen, CCCD, gioiTinh, birthday, email, soDienThoai, thanhPho, quan, ngheNghiep, diaChi
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (show) {
      gSLCCCD()

      if (!sLProfession.length)
        gSLProfession()
      if (!sLProvice.length)
        gSLProvice()
    } else {
      setIsSelectedCCCD(false)
      form.resetFields()
      // setProvice(undefined)
      // setDistrict(undefined)
      setBirthday(undefined)
      setSLDistrict([])
    }
  }, [show])



  useEffect(() => {
    if (infoBusinessCustomer && show) {
      fomatDataForm(true, infoBusinessCustomer)
      setIsSelectedCCCD(true)
    }
  }, [infoBusinessCustomer, show])

  return (

    <Form
      ref={formRef}
      form={form}
      className='rs-form add-relative-form'
      onFinish={onFormFinish}
    >
      <Modal
        open={show}
        title='Chỉnh sửa người liên hệ'
        className='rs-modal w-572 footer-content-end add-relative-modal'
        centered
        footer={
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            loading={loading}
            onClick={() => formRef?.current.submit()}
          >Lưu</Button>
        }
        onCancel={modalClose}
      >
        <Form.Item
          layout='vertical'
          label="CCCD"
          name="CCCD"
          rules={[
            { required: true, message: 'Vui lòng nhập CCCD' },
            {
              pattern: /^\d{12}$/,
              message: 'Căn cước công dân phải là 12 số'
            }
          ]}
        >
          <AutoComplete

            placeholder="Nhập CCCD"
            disabled={isSelectedCCCD}
            options={sLCCCD} // Danh sách gợi ý
            onSearch={handleSearchCCCD} // Sự kiện tìm kiếm
            onSelect={handleSelectCCCD}
          >
            <Input className="rs-input rs-input--32" />
          </AutoComplete>
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Họ và tên'
          name='ho-ten'
          rules={[
            { required: true, message: "Vui lòng nhập Họ và tên" }
          ]}
        >
          <Input
            placeholder='Họ và tên'
            className='rs-input rs-input--32'
            disabled={isSelectedCCCD}
          />
        </Form.Item>

        <Form.Item
          label=''
          name='gioi-tinh'
          rules={[
            { required: true, message: "Vui lòng chọn giới tính" }
          ]}
          className='pt-3'
        >
          <Radio.Group
            className='rs-radio-group gender-group'
          >
            {
              genders.map((item: any) => (
                <Radio.Button
                  key={item.value}
                  value={item.value}
                  className='rs-radio'
                >
                  <span className='inner-text'>{item.icon}{item.label}</span>
                </Radio.Button>
              ))
            }
          </Radio.Group>
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Email'
          name='email'
        >
          <Input
            placeholder='Email'
            className='rs-input rs-input--32'
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Số điện thoại'
          name='so-dien-thoai'
          rules={[
            { required: true, message: "Vui lòng nhập số điện thoại" },
            {
              pattern: /^0\d{9}$/,
              message: "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)",
            },
          ]}
        >
          <Input
            placeholder='Số điện thoại'
            className='rs-input rs-input--32'
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Sinh nhật'
          name='sinh-nhat'
          rules={[
            { required: true, message: "Vui lòng chọn ngày sinh" }
          ]}
        >
          <DatePicker
            placeholder='Chọn ngày sinh'
            className='rs-date-picker w-full'
            popupClassName='rs-date-picker-dropdown'
            format='DD/MM/YYYY'
            disabledDate={(current) => current && current > dayjs().endOf('day')}
            value={birthday ? dayjs(birthday, 'YYYY/MM/DD') : null}
            onChange={(e) => setBirthday(handleDateChangeDayJs(e))}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Nghề nghiệp'
          name='nghe-nghiep'
          rules={[
            { required: true, message: "Vui lòng chọn nghề nghiệp" }
          ]}
        >
          <Select
            placeholder='Nghề nghiệp'
            className='rs-select'

            options={sLProfession}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Địa chỉ'
        >
          <Flex vertical className='gap-4px'>
            <Flex className='gap-10px'>
              <Form.Item
                label=''
                name='thanh-pho'
                rules={[
                  { required: true, message: "Vui lòng chọn tỉnh/ thành phố" }
                ]}
                className='w-full'
              >
                <Select
                  placeholder='Chọn tỉnh/thành phố'
                  className='rs-select'

                  options={sLProvice}
                  onChange={(e) => onChaneProvice(e)}
                />
              </Form.Item>

              <Form.Item
                label=''
                name='quan'
                rules={[
                  { required: true, message: "Vui lòng chọn quận/ huyện" }
                ]}
                className='w-full'
              >
                <Select
                  placeholder='Chọn quận/huyện'
                  className='rs-select'

                  options={sLDistrict}
                />
              </Form.Item>
            </Flex>

            <Form.Item
              label=''
              name='dia-chi'
            // rules={[
            //   { required: true, message: "Vui lòng nhập địa chỉ" }
            // ]}
            >
              <Input
                placeholder='Địa chỉ'
                className='rs-input rs-input--32'
              />
            </Form.Item>
          </Flex>
        </Form.Item>

      </Modal >
    </Form>
  )
}

export default ModalUpdateContactCustomer
